var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6679 8.13303C14.688 7.15439 14.4924 6.18331 14.095 5.28879C13.6975 4.39426 13.1079 3.59823 12.3681 2.95725C11.6283 2.31627 10.7565 1.84606 9.81445 1.58003C8.87245 1.314 7.88341 1.25868 6.91761 1.41799C5.95181 1.57729 5.03294 1.94733 4.22627 2.5018C3.4196 3.05627 2.74493 3.78157 2.25018 4.62619C1.75543 5.47081 1.45275 6.41401 1.36363 7.3888C1.27451 8.36359 1.40114 9.34604 1.73452 10.2664C1.86786 10.5997 2.26786 10.9997 2.60119 11.133L11.4012 14.533C11.7345 14.6664 12.2012 14.533 12.4679 14.333L14.2012 12.5997C14.4679 12.333 14.6679 11.7997 14.6679 11.4664V8.13303Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5337 11.9995L7.53371 9.33282C7.23628 9.22351 6.98617 9.00901 6.82792 8.72753C6.66968 8.44604 6.61357 8.11584 6.66959 7.79573C6.72561 7.47562 6.89012 7.18638 7.13382 6.97952C7.37753 6.77266 7.68461 6.66161 8.00038 6.66615H14.5337",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoc);
export default __webpack_public_path__ + "static/media/poc.544a9614a83b0b0d315d4098072d5c08.svg";
export { ForwardRef as ReactComponent };